module.exports = __webpack_public_path__ + "img/download.cee83684.svg";